import NotificationItem from "./NotificationItem";

function NotificationItemToggle(props) {
    const platform = localStorage.getItem("indi-platform");
    const hasNotificationPermission = localStorage.getItem("has-notification-permission");
    const isNotifOptedIn = localStorage.getItem("notification-opted-in");
    const hasLocationPermission = localStorage.getItem("has-location-permission");

    const hasNoNotifPermission = hasNotificationPermission == "0" || hasNotificationPermission == null;
    const notOpted = isNotifOptedIn == "0" || isNotifOptedIn == null;

    return (platform && (hasNoNotifPermission || notOpted)) ? (
        <NotificationItem
            title={"Be the First to Know!"}
            description={"Turn on your notifications today"}
            date={null}
            viewed={0}
            icon={{
                type: "main",
                name: "bell2",
            }}
            gradient={"#d37536-#d37536"}
            notification={{
                type: "toggle"
            }}
            closeNotificationDrawer={props?.closeNotificationDrawer}
        />
    ) : "";
}

export default NotificationItemToggle;